<template>
  <div class="mobile-money has-text-left">
    <!-- Content -->
    <div class="row">
      <div class="col-12 col-md-7">
        <div class="rounded background-light-gray border border-dark-gray p-3">
          <form @submit.prevent="submit">
            <div class="row">
              <div class="col-12">
                <h5 class="font-weight-bold">Pay With Wallet Options</h5>
                <!-- Pay with wallet balance -->
                <div class="row d-flex flex-column-reverse flex-lg-row align-items-center mb-4">
                  <div class="col-12 col-lg-6">
                    <b-button variant="primary" class="py-4 w-100 btn btn-primary" @click.prevent="handlePayWallet" :disabled="walletBalances.topupBalance < payVendorState.transaction_amount">Pay With Wallet Balance</b-button>
                  </div>
                  <div class="col-12 col-lg-6" v-if="walletBalances.currency">
                    <p class="mb-2 mb-lg-0">(Wallet Balance: <span class="text-primary">{{ walletBalances.topupBalance }} {{ walletBalances.currency.code }}</span>)</p>
                  </div>
                </div>
                
                <!-- Pay with Loan balance -->
                <div class="row d-flex flex-column-reverse flex-lg-row align-items-center">
                  <div class="col-12 col-lg-6">
                    <b-button variant="primary" class="py-4 w-100 btn btn-primary" @click.prevent="handlePayLoan" :disabled="walletBalances.creditBalance <= payVendorState.transaction_amount">Pay With Loan Balance</b-button>
                  </div>
                  <div class="col-12 col-lg-6" v-if="walletBalances.currency">
                    <p class="mb-2 mb-lg-0">(Loan Balance: <span class="text-primary">{{ walletBalances.creditBalance }} {{ walletBalances.currency.code }}</span>)</p>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TransactionAPI from '../api/transactions_api';
import store from '../store';

export default {
  data() {
    return {
      selected: 'GHS',
      options: [
        { text: 'GHS', value: 'GHS' },
        { text: 'USD', value: 'USD' },
        { text: 'EUR', value: 'EUR' },
        { text: 'GBP', value: 'GBP' }
      ],
      transaction_amount: null,
      loading: false,
      message: 'Payment Successfully Made.'
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    payVendorState: {
      get: function () {
        return store.state.payVendorState;
      },
      set: function (newValue) {
        store.state.payVendorState = newValue;
      }
    },
    payerCheckoutInfo: {
      get: function () {
        return store.state.payerCheckoutInfo;
      },
      set: function (newValue) {
        store.state.payerCheckoutInfo = newValue;
      }
    },
    vendorStats: {
      get: function () {
        return store.state.vendorStats;
      },
      set: function (newValue) {
        store.state.vendorStats = newValue;
      }
    },
    walletBalances: {
      get: function () {
        return store.state.walletBalances;
      },
      set: function (newValue) {
        store.state.walletBalances = newValue;
      }
    },
  },
  methods: {
    init() {
      var  id = this.$route.params.id ? this.$route.params.id : 0;

      TransactionAPI.methods.getWalletBalances();
      TransactionAPI.methods.getVendorDashboardStats();

      if (store.state.payVendorState.payment_method == null) {
        if (id > 0) {
          this.$router.push({ name: 'Payment Methods', params: { id: id} });
        } else {
          this.$router.push({ name: 'Vendors'});
        }
      }
    },
    submit() {

    },
    handlePayLoan() {
      this.payVendorState.payment_method = 'creditBalance';
      this.$router.push({ name: 'Make Payment Summary' });
    },
    handlePayWallet() {
      this.payVendorState.payment_method = 'topupBalance';
      this.$router.push({ name: 'Make Payment Summary' });
    }
  }
};
</script>
<style scoped>
.section .title-divider {
  margin: auto;
  width: 100px;
  height: 5px;
  background: #00a27f;
}
.light-subtitle {
  font-size: 1.5rem;
  padding: 2% 10% 2% 10%;
  margin-bottom: 0 !important;
  font-weight: 400;
  line-height: normal;
  font-family: Roboto, sans-serif;
}
.text-big {
  font-size: 3em;
}
.text-blue {
  color: #0085ba;
}
.background-light-gray {
  background: #f2f2f2;
}
.border-dark-gray {
  border-color: #d9d9d9 !important;
}
.red {
  color: red;
}
.green { 
  color: green;
}
.b-skeleton-wrapper {
  width: 90%;
}
.reflect-rotate {
  transform: rotate(275deg) scaleX(-1);
}
@media (min-width: 768px) {
  .d-md-inline-table {
    display: inline-table !important;
  }
}
@media (max-width: 768px) {
  .rounded-pill {
    border-radius: 5px !important;
  }
}
</style>
